import * as R from 'ramda'

async function fetchData (url, options) {
  try {
    const response = await fetch(url, options)

    if (!response.ok) {
      return { type: 'http_error', status: response.status }
      // throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.json()
    // console.log('Data:', data)

    const errorMessage = R.path(['error', 'message'], data)
    if (errorMessage) { return { type: 'known_error', errorMessage } }
    return { type: 'success', data }
  } catch (error) {
    if (error instanceof TypeError) {
      // console.error('Network error or failed request:', error.message)
      return { type: 'network_or_failed_request_error', errorMessage: error.message }
    } else if (error instanceof SyntaxError) {
      // console.error('JSON parse error:', error.message)
      return { type: 'json_parse_error', errorMessage: error.message }
    } else {
      // console.error('Other error:', error.message)
      return { type: 'other_error', errorMessage: error.message }
    }
  }
}

export default async function postDataAsync ({
  url,
  csrfToken,
  bodyData,
  onError,
  onSuccess,
}) {
  const fetchData_response = await fetchData(url, {
    method: 'POST',
    // to fix the error on second send
    //
    // WARN -- : Can't verify CSRF token authenticity.
    // INFO -- : Completed 422 Unprocessable Entity in 1ms (Allocations: 1322)
    // DEBUG -- : Can't verify CSRF token authenticity. excluded from capture: DSN not set
    // FATAL -- : ActionController::InvalidAuthenticityToken (Can't verify CSRF token authenticity.):
    //
    // https://bloggie.io/@kinopyo/sending-non-get-requests-with-fetch-javascript-api-in-rails
    credentials: 'same-origin',
    /// /
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(bodyData),
  })

  switch (fetchData_response.type) {
    case 'http_error':
      onError(`HTTP error! Status: ${fetchData_response.status}`)
      break
    case 'network_or_failed_request_error':
      onError(`Network error or failed request: ${fetchData_response.errorMessage}`)
      break
    case 'json_parse_error':
      onError(`JSON parse error: ${fetchData_response.errorMessage}`)
      break
    case 'other_error':
      onError(`Other error: ${fetchData_response.errorMessage}`)
      break

    case 'known_error':
      onError(fetchData_response.errorMessage)
      break

    case 'success': {
      const { data } = fetchData_response
      const title = R.path(['data', 'message_title'], data) || 'Thank You for donation'
      const text = R.path(['data', 'message_text'], data) || 'Donation was processed'
      onSuccess({ title, text })
      break
    }
    default:
      throw new Error(`unknown type: ${fetchData_response.type}`)
  }
}
